import { AxiosError } from 'axios';
import adminApi from '../../api/adminApi';
import useStore from '../../store/store';

export interface AddRawDataFileParams {
    kitId: number;
    releaseDate: Date;
    rawDataFile?: File;
}

const AddRawDataFile = async (params: AddRawDataFileParams) => {
    const { setFormError, setIsLoading } = useStore.getState();
    setIsLoading(true);

    try {
        const formData = new FormData();
        formData.append('kitId', params.kitId.toString());
        formData.append('releaseDate', params.releaseDate.toISOString());
        if (params.rawDataFile) {
            formData.append('rawDataFile', params.rawDataFile);
        }

        const response = await adminApi.post('/raw-data-file/add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const { success, errCode } = response.data;
        if (success) {
            setFormError('');
        } else if (errCode) {
            setFormError(errCode);
        } else {
            setFormError('other');
        }
    } catch (e: unknown) {
        if (e instanceof AxiosError) {
            console.error('AxiosError:', e);
            console.error('e.message:', e.message);
            console.error('e.code:', e.code);
            console.error('e.config:', e.config);
            setFormError('');
            setTimeout(() => setFormError(e.code ?? 'other'), 0);
        } else {
            console.error('Non-Axios error:', e);
            setFormError('');
            setTimeout(() => setFormError('other'), 0);
        }
    } finally {
        setIsLoading(false);
    }
};

export default AddRawDataFile;
